export default __webpack_public_path__ + "static/media/fonts/alegreyasans-black-webfont.0d98cd20.woff2";